import {
  AlertBannerContent,
  AlertBannerContentWithRequiredFields,
} from "./components/AlertBanner/alertBanner.types";

export const hasContentToDisplay = (
  content?: AlertBannerContent
): content is AlertBannerContentWithRequiredFields => {
  return (
    typeof content === "object" &&
    content.active === "true" &&
    !!content.message?.trim() &&
    !!content.id?.trim()
  );
};

export const hasDismissedAlert = (contentId?: string) =>
  contentId
    ? localStorage.getItem(generateAlertDismissalStorageKey(contentId)) ===
      "true"
    : false;

export const generateAlertDismissalStorageKey = (contentId: string) =>
  `dismissed-alert-${contentId}`;
